<template>
  <a-card :bordered="false">
  <a-form >
    <a-form-item
      label="聊天室"
      :required="true"
      :labelCol="labelCol"
      :wrapperCol="wrapperCol"
      validateStatus="success"
    >
      <div style="display: flex;">
<!--        <a-input  type="number"   placeholder="输入编号"@input="search($event)"></a-input>-->
        <a-input  v-model="num" type="number"   placeholder="输入编号"></a-input>
        <a-button type="primary"  @click="submitOk" style="width: 80px;margin-left: 5px">确定</a-button>
      </div>
    </a-form-item>

  </a-form>
  </a-card>
</template>


<script>
  import { httpAction, getAction,putAction } from '@api/manage'
export default {
name: "DoctorInfo",

  data() {
    return {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 10 },
      },
      num:" ",
      url: {
        doctorUser:"/dwuRelation/dwuRelation/doctorUser",
      },
    }
  },
  created() {

  },
  methods: {
    submitOk() {
      let num = {"num":this.num};


      getAction(this.url.doctorUser,num).then(res => {
       console.log(res)

      })
    },

  }

}
</script>

<style scoped>

</style>